export const USEREMAILCONFIG_SET_LOADING_STATE = 'USEREMAILCONFIG_SET_LOADING_STATE';
export const USEREMAILCONFIG_SET_DATA_LOADING_STATE = 'USEREMAILCONFIG_SET_DATA_LOADING_STATE';
export const USEREMAILCONFIG_SET_REQUEST_LOADING_STATE =
  'USEREMAILCONFIG_SET_REQUEST_LOADING_STATE';
export const USEREMAILCONFIG_SET_ERROR = 'USEREMAILCONFIG_SET_ERROR';
export const USEREMAILCONFIG_RESET_ERROR = 'USEREMAILCONFIG_RESET_ERROR';
export const USEREMAILCONFIG_SET_EMAIL_CONFIG_DATA = 'USEREMAILCONFIG_SET_EMAIL_CONFIG_DATA';
